import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';
import { TouchableOpacity } from 'react-native';

import { theme } from 'styles/configure-theme';
import { routes } from 'utils/routing';

export const HamburgerButton: React.FC<React.PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  return (
    <TouchableOpacity
      hitSlop={15}
      testID="hamburger-menu-button"
      onPress={() => router.navigate(routes.account)}
      accessibilityLabel={formatMessage({ id: 'hamburgerMenuAriaLabel' })}
    >
      <Icon variant="menu" color={theme.token('icon-header-contrast')} aria-hidden size="$6" />
    </TouchableOpacity>
  );
};
